import decode from 'jwt-decode';
import {BaseService} from './BaseService';
export default class CalendarServices extends BaseService {
  getProfile() {
      // Using jwt-decode npm package to decode the token
      return decode(this.getToken());
  }

  postCalendar(calendar) {
      return this.fetch(`${this.domain}/calendar`, {
          method: 'POST',
          body: JSON.stringify({
            calendario: calendar,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  setOwnCalendarChecked(checked, calendarioid) {
      return this.fetch(`${this.domain}/calendar/check`, {
          method: 'PUT',
          body: JSON.stringify({
            checked: checked ? 1 : 0,
            calendarioid,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  getUserCalendars() {
      return this.fetch(`${this.domain}/calendar/user`, {
          method: 'GET',
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  getOwnCalendars() {
      return this.fetch(`${this.domain}/calendar/owned`, {
          method: 'GET',
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  getPublicCalendars() {
      return this.fetch(`${this.domain}/calendar/public`, {
          method: 'GET',
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  saveUserCalendar(userCalendar) {
      return this.fetch(`${this.domain}/calendar/user`, {
          method: 'POST',
          body: JSON.stringify({
            usercalendar: userCalendar,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  getDrawCalendar() {
      return this.fetch(`${this.domain}/calendar`, {
          method: 'GET',
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  postEvent(event) {
    return this.fetch(`${this.domain}/calendar/event`, {
        method: 'POST',
        body: JSON.stringify({
          evento: event,
        })
    }).then(res => {
        return Promise.resolve(res);
    });
  }

  getEventById(id) {
    const url = new URL(`${this.domain}/calendar/event`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }

  postEventAssistant(assistants) {
    const event = {assistants}
    return this.fetch(`${this.domain}/calendar/event/assistants`, {
        method: 'POST',
        body: JSON.stringify({
          event,
        })
    }).then(res => {
        return Promise.resolve(res);
    });
  }

  postEventFile(archivo) {
    const formdata = new FormData();
    formdata.append('file', archivo.file);
    formdata.append('nombre', archivo.nombre);
    formdata.append('description', archivo.description);
    formdata.append('eventoid', archivo.eventoid);
    return fetch(`${this.domain}/calendar/event/file`, {
          headers : {'Authorization':'Bearer ' + this.getToken()},
          method: 'POST',
          body: formdata,
        })
        .then(this._checkStatus)
        .then( response => {
          return Promise.resolve(response);
        });
  }

  deleteUserCalendar(propio, id) {
    const usercalendar = {isown: propio, usercalendarid: id}
    return this.fetch(`${this.domain}/calendar/user`, {
        method: 'DELETE',
        body: JSON.stringify({
          usercalendar,
        })
    }).then(res => {
        return Promise.resolve(res);
    });
  }

  exportCalendar(exported) {
    return this.fetchCSV(`${this.domain}/calendar/export`, {
        method: 'POST',
        body: JSON.stringify({
          exported,
        }),
    })
    .then(res => {
      return Promise.resolve(res);
    })
    .catch(err => {
      console.log(err);
    });
  }

  importCalendar(data) {
    const formdata = new FormData();
    formdata.append('file', data.file);
    formdata.append('id', data.id);
    return fetch(`${this.domain}/calendar/import/ics`, {
          headers : {'Authorization':'Bearer ' + this.getToken()},
          method: 'POST',
          body: formdata,
        })
        .then(this._checkStatus)
        .then( response => {
          return Promise.resolve(response);
        });
  }

  deleteEvent(id) {
    const event = {id}
    return this.fetch(`${this.domain}/calendar/event`, {
        method: 'DELETE',
        body: JSON.stringify({
          event,
        })
    }).then(res => {
        return Promise.resolve(res);
    });
  }

}



// WEBPACK FOOTER //
// ./src/services/CalendarServices.js